import { HttpMethod } from "../components/Common/useFetch";
import { RequestOptions } from "../components/Common/useRequest";
import useUserRequest, { UserRequestSpec } from "../components/Common/useUserRequest";

const postSpec = (userId: string): UserRequestSpec => ({
  path: `/api/users/${userId}/userAgreement`,
  method: HttpMethod.POST,
});

const useAddUserAgreement = (userId: string, options?: RequestOptions<string>) =>
  useUserRequest<void, string>(
    postSpec(userId),
    options);

export default useAddUserAgreement;